// Locale + multilingual-message resolution helpers.
//
// The actor-facing app ships with EN + ES + ZH copy via `@ohear/shared/copy`.
// This module supplies the runtime types and small helpers that map a `Locale`
// to the appropriate string on a `MultilingualMessage`. It is intentionally
// dependency-free so it can be imported from the API, the app, and any future
// background worker without dragging React or DOM globals in.
/** Default locale when no preference exists and detection fails. */
export const DEFAULT_LOCALE = 'en';
/** Locales the UI can render. Drives the language switcher option list. */
export const SUPPORTED_LOCALES = ['en', 'es', 'zh'];
/**
 * Pick the right localized string off a `MultilingualMessage`. Falls back to
 * the default locale if the requested one is missing (e.g. partial
 * translation).
 */
export function resolveMessage(msg, locale) {
    return msg[locale] ?? msg[DEFAULT_LOCALE];
}
/** Build a translator bound to a single locale. Cheap; safe to memoize. */
export function makeTranslator(locale) {
    return (msg) => {
        if (typeof msg === 'string')
            return msg;
        return resolveMessage(msg, locale);
    };
}
/** Type guard for locale strings coming out of localStorage / API / etc. */
export function isLocale(s) {
    return s === 'en' || s === 'es' || s === 'zh';
}
